export const gl = (code='', uniforms={}, variables={}, functions={}, closure= {}) => {
    return {
        code,
        uniforms,
        variables,
        functions,
        closure
    };
};
